import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import MenuItem from '@mui/material/MenuItem';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';
import { ControlSelect } from '../../common/ControlSelect';

const MIN_FONT_SIZE = 1;
const MAX_FONT_SIZE = 300;
const clampValue = (value: number) => Math.min(Math.max(value, MIN_FONT_SIZE), MAX_FONT_SIZE);

export const FontSizeControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const elements = store.selectedElements;
    const element = elements?.[0] as ElementType & { fontSize: number };

    const handleSetFixedSize = (fontSize: string) => {
        elements.forEach(element => element.set({ fontSize: clampValue(+fontSize) }));
    };

    return (
        <ControlSelect
            onChange={e => handleSetFixedSize(e.target.value as string)}
            value={element?.fontSize ? +element.fontSize.toFixed(0) : undefined}>
            {Array.from(Array(300).keys()).map((_, index) => (
                <MenuItem key={index} value={index + 1}>
                    {index + 1}px
                </MenuItem>
            ))}
        </ControlSelect>
    );
});
